<template>
    <svg
        class="fill-current"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23.2684 16.6805C23.6246 16.2968 23.6246 15.7032 23.2684 15.3196L21.2936 13.1929C19.9952 11.7945 18.1731 11 16.2649 11C14.3566 11 12.5346 11.7945 11.2361 13.1929L9.26135 15.3195C8.90507 15.7032 8.90507 16.2968 9.26135 16.6804L11.2361 18.8071C12.5346 20.2055 14.3566 21 16.2649 21C18.1731 21 19.9952 20.2055 21.2936 18.8071L23.2684 16.6805ZM24.734 13.9586C25.8028 15.1097 25.8028 16.8903 24.734 18.0414L22.7592 20.168C21.0823 21.9739 18.7292 23 16.2649 23C13.8005 23 11.4474 21.9739 9.77052 20.168L7.79576 18.0414C6.72693 16.8903 6.72694 15.1097 7.79576 13.9586L9.77052 11.832C11.4474 10.0261 13.8005 9 16.2649 9C18.7292 9 21.0823 10.0261 22.7592 11.832L24.734 13.9586Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.2649 16C13.2649 17.6569 14.608 19 16.2649 19C17.9217 19 19.2649 17.6569 19.2649 16C19.2649 15.1716 18.9291 14.4216 18.3862 13.8787L16.2649 16V13C14.608 13 13.2649 14.3431 13.2649 16Z"
        />
    </svg>
</template>
